export default {
  pageTitle: {
    id: 'merchant_register_page_title',
    defaultMessage: 'Become a Back Market seller',
  },
  punchline: {
    id: 'merchant_register_page_login_punchline',
    defaultMessage:
      '{purpleWord, html} your business on the leading marketplace for renewed devices.',
  },
  punchlinePurpleWord: {
    id: 'merchant_register_page_login_punchline_purple_word',
    defaultMessage: 'Grow',
  },
  SEOpageTitle: {
    id: 'merchant_register_page_SEO_page_title',
    defaultMessage:
      'Sell your refurbished products on the Back Market marketplace',
  },
  SEOpageTitleCompanyName: {
    id: 'page_meta_title_company_name',
    defaultMessage: 'Back Market',
  },
  SEOpageDescription: {
    id: 'merchant_register_page_SEO_page_description',
    defaultMessage:
      'Become an official Back Market seller: Manage your inventory wisely, adjust your prices, automate management and improve your revenues.',
  },
  connectedUserText: {
    id: 'bo_seller.register.connected_user_text',
    defaultMessage: 'You are connected as {email}',
  },
  logoutLink: {
    id: 'bo_seller.register.logout_link',
    defaultMessage: 'Not you?',
  },
}
